import { Element, htmlToDOM, Text, type DOMNode } from 'html-react-parser';

const TEXT_BREAKS = new Set([
    'blockquote',
    'br',
    'div',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'li',
    'p',
]);

export function plainTextFromHtml(raw: string | undefined | null): string {
    if (!raw || typeof raw !== 'string') return '';

    let text = '';
    let pendingSpace = false;

    const append = (value: string) => {
        for (const character of value) {
            if (!character.trim()) {
                pendingSpace = text.length > 0;
                continue;
            }

            if (pendingSpace) text += ' ';
            text += character;
            pendingSpace = false;
        }
    };

    const visit = (nodes: DOMNode[]) => {
        nodes.forEach((node) => {
            if (node instanceof Text) append(node.data);
            if (node instanceof Element) {
                visit(node.children);
                if (TEXT_BREAKS.has(node.name)) pendingSpace = text.length > 0;
            }
        });
    };

    visit(htmlToDOM(raw));
    return text;
}
